// extracted by css-extract-rspack-plugin
export default {"root":"jSAsSqVXDp0yJuSA","active":"FftCBz8JAgRLCLAI","icon":"ubYfHD9HQfQmf36_","iconAsc":"vLR1HUniIVg8SuBs","iconDesc":"UJ7BrCnriZ4U3_kK"};